module.exports = __webpack_public_path__ + "static/media/icon-clinic.dd86934e.svg";